import { render, staticRenderFns } from "./AuthBlitzFrame.vue?vue&type=template&id=24dcb07e&scoped=true&"
import script from "./AuthBlitzFrame.vue?vue&type=script&lang=ts&"
export * from "./AuthBlitzFrame.vue?vue&type=script&lang=ts&"
import style0 from "./AuthBlitzFrame.vue?vue&type=style&index=0&id=24dcb07e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dcb07e",
  null
  
)

export default component.exports